// src/util/analytics.js
// One GA4 event (newsletter_signup) + a signup_source parameter,
// sent with window.gtag — the same way ServicesSection/planSection.js does it.

export const SIGNUP_SOURCE = {
    HOMEPAGE_POPUP: 'homepage_popup',
    BLOG_POPUP: 'blog_popup',
    FOOTER: 'footer',
    ORG_FORM: 'org_form',
    KNOWLEDGE_HUB: 'knowledge_hub',
};

const GA4_ID = 'G-34FQJZ2P9G';

export const trackNewsletterSignup = source => {
    console.log('[GA debug]', {
        source,
        flag: process.env.REACT_APP_GOOGLE_ANALYTICS,
        gtagType: typeof window.gtag,
    });

    const enabled = process.env.REACT_APP_GOOGLE_ANALYTICS;
    if (!enabled || typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return;
    }

    window.gtag('event', 'newsletter_signup', {
        send_to: GA4_ID,
        signup_source: source,
    });
};
